'use strict';

angular.module('shiftTraderApp')
  .factory('HardNavigationService', function ($window, $state) {
    return {
      navigateTo: function (route, forceHard) {
        if (route !== 'enter' || forceHard) {
          $window.location = $window.location.protocol + '//' + $window.location.hostname + ($window.location.port ? (':' + $window.location.port) : '') + $window.location.pathname + '#/' + route;
        } else {
          $state.go('enter', {reload: true});
        }
      },
      replace: function(route) {
        var temp = $window.location.protocol + '//' + $window.location.hostname + ($window.location.port ? (':' + $window.location.port) : '') + $window.location.pathname + '#/' + route;
        $window.location.replace(temp);
      }
    };
  });
